import type React from "react"

interface ImageProps {
  src: string
  alt: string
  width?: number
  height?: number
  className?: string
  loading?: "lazy" | "eager"
}

const Image: React.FC<ImageProps> = ({ src, alt, width, height, className = "", loading = "lazy" }) => {
  return (
    <img
      src={src || "/placeholder.svg"}
      alt={alt}
      width={width}
      height={height}
      className={className}
      loading={loading}
      onError={(e) => {
        const target = e.target as HTMLImageElement
        target.src = `https://placehold.co/${width || 400}x${height || 300}?text=Image+Not+Found`
      }}
    />
  )
}

export default Image
